<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="5">
          <span>PAGOS: SOLICITUDES DE PAGOS AGRUPADOS</span>
        </v-col>

        <v-col cols="12" md="6" lg="5">
          <v-pagination
            class="custom-pagination"
            v-model="pagina"
            :length="metadatos?.totalPaginas || 0"
            :total-visible="10"
            @input="listar"></v-pagination>
        </v-col>

        <v-col cols="12" md="6" lg="2">
          <v-select
            :items="[10, 25, 50, 75, 100]"
            label="Items por página"
            v-model="itemsPorPagina"
            outlined
            dense
            hide-details
            :disabled="items.length == 0"
            @change="cambiarPagina" />
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col v-if="this.$store.state.CARGO.id == 1" cols="12" md="3" xl="2">
        <div class="d-flex">
          <v-switch
            style="margin-top: -4px"
            v-model="mostrarTodasSedes"
            hide-details
            label="Ver todas las sedes"></v-switch>
        </div>
      </v-col>

      <v-col cols="12" :md="this.$store.state.CARGO.id == 1 ? 4 : 7" :xl="this.$store.state.CARGO.id == 1 ? 6 : 8">
        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          color="primary"
          title="Registrar"
          small
          @click="$refs.modalFormularioSolicitudePagoAgrupadoRef.abrir(accionesCrud.REGISTRAR, [])">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn class="mx-1" title="Editar" small :disabled="item == null" @click="editar(item)">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2 || permisosGestionEmpresarial || permisosContabilidadNacional"
          small
          class="mx-1"
          :disabled="item == null"
          title="Realizar Pagos"
          @click="$refs.modalPagosUniversidadesAgrupadosRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-cash</v-icon>

          Realizar Pagos
        </v-btn>
      </v-col>

      <v-col cols="12" md="2" xl="2">
        <div class="d-flex">
          <v-switch
            style="margin-top: -4px"
            v-model="mostradoDetalleSolicitudesPagosAgrupados"
            hide-details
            label="Mostrar detalles"></v-switch>
        </div>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoSolicitudesPagosPadresPaginados
          ref="listadoRef"
          :items="items"
          :cargando="cargando"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormularioSolicitudePagoAgrupado
      ref="modalFormularioSolicitudePagoAgrupadoRef"
      :nombreRecurso="nombreItem"
      @actualizarListado="listar" />

    <ModalPagosUniversidadesAgrupados
      ref="modalPagosUniversidadesAgrupadosRef"
      :nombreRecurso="nombreItem"
      @actualizarListado="listar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoSolicitudesPagosPadresPaginados from '../components/ListadoSolicitudesPagosPadresPaginados.vue';
import ModalFormularioSolicitudePagoAgrupado from '../components/ModalFormularioSolicitudesPagosAgrupados.vue';
import SolicitudPagoPadreService from '../services/solicitud-pago-padre.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import { mapGetters } from 'vuex';
import ModalPagosUniversidadesAgrupados from '../components/ModalPagosUniversidadesAgrupados.vue';

export default {
  name: 'SolicitudesPagosAgrupadosLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoSolicitudesPagosPadresPaginados,
    ModalFormularioSolicitudePagoAgrupado,
    ModalPagosUniversidadesAgrupados,
  },
  data() {
    return {
      nombreItem: 'Pago Universidad',
      solicitudPagoPadre: null,
      cargandoSolicitudPagoPadre: false,
      mostrarTodasSedes: false,
    };
  },
  mounted() {
    this.listar();
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      if (!this.mostrarTodasSedes) {
        this.listarRestableciendoPagina();
      }
    },
    mostrarTodasSedes() {
      this.listarRestableciendoPagina();
    },
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosGestionEmpresarial: 'pago/permisosGestionEmpresarial',
      permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
    }),
    mostradoDetalleSolicitudesPagosAgrupados: {
      get() {
        return this.$store.state.listado.mostradoDetalleSolicitudesPagosAgrupados;
      },
      set(value) {
        this.$store.dispatch('listado/setMostradoDetalleSolicitudesPagosAgrupados', value);
      },
    },
    yaTienePagosUniversidades() {
      return this?.item?.solicitudesPagos?.some((solicitudPago) => solicitudPago.pagosUniversidades.length > 0);
    },
  },
  methods: {
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      };

      this.obtenerDatosPaginadosConNotificacion(
        SolicitudPagoPadreService.findAllPaginado,
        'items',
        'metadatos',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    editar(item) {
      if (this.yaTienePagosUniversidades) {
        this.$notify({
          group: 'notifications',
          title: 'Error al editar',
          text: 'No se puede editar porque ya tiene pagos universidades registrados',
          type: 'error',
        });

        return;
      }

      this.$refs.modalFormularioSolicitudePagoAgrupadoRef.abrir(this.accionesCrud.EDITAR, item);
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>